import React from 'react'
import { useTranslation } from '@mc/i18n'
import { BenefitTrans, TableHeader, useTiersInfo } from '@mc/plans-ui'
import { usePlusBadges } from '../../../../experiments/prcng-1109_v1_plus_badge'
import { CHECKOUT_I18N_NAMESPACE } from '../../../../i18n'

export const RegularHeader = () => {
  const { individual, duo, family } = useTiersInfo()

  return (
    <>
      <TableHeader.Titles>
        <TableHeader.IndividualTitle>
          {individual.displayName}
        </TableHeader.IndividualTitle>
        <TableHeader.DuoTitle>{duo.displayName}</TableHeader.DuoTitle>
        <TableHeader.FamilyTitle>{family.displayName}</TableHeader.FamilyTitle>
      </TableHeader.Titles>

      <TableHeader.Actions>
        <RegularActions />
      </TableHeader.Actions>
    </>
  )
}

const RegularActions = () => {
  const { t } = useTranslation(CHECKOUT_I18N_NAMESPACE)
  const { individual, duo, family } = useTiersInfo()
  const { duoBadge, familyBadge } = usePlusBadges()

  return (
    <>
      <TableHeader.IndividualAction
        description={
          <>
            <BenefitTrans
              ns={CHECKOUT_I18N_NAMESPACE}
              i18nKey='plans.headers.devicesInfo'
              tier={individual}
              name='concurrent_devices'
            />
            <br />
            <BenefitTrans
              ns={CHECKOUT_I18N_NAMESPACE}
              i18nKey='plans.headers.offlineMode'
              tier={individual}
              name='offline_download'
              defaultValue={false}
            />
          </>
        }
        label={t('plans.headers.cta.label', {
          plan: individual.displayName,
        })}
        selectedLabel={t('plans.headers.cta.selected')}
        unselectedLabel={t('plans.headers.cta.select')}
      />
      <TableHeader.DuoAction
        description={
          <>
            <BenefitTrans
              ns={CHECKOUT_I18N_NAMESPACE}
              i18nKey='plans.headers.devicesInfo'
              tier={duo}
              name='concurrent_devices'
            />
            <br />
            <BenefitTrans
              ns={CHECKOUT_I18N_NAMESPACE}
              i18nKey='plans.headers.offlineMode'
              tier={duo}
              name='offline_download'
            />
          </>
        }
        label={t('plans.headers.cta.label', {
          plan: duo.displayName,
        })}
        selectedLabel={t('plans.headers.cta.selected')}
        unselectedLabel={t('plans.headers.cta.select')}
        badge={duoBadge}
      />
      <TableHeader.FamilyAction
        description={
          <>
            <BenefitTrans
              ns={CHECKOUT_I18N_NAMESPACE}
              i18nKey='plans.headers.devicesInfo'
              tier={family}
              name='concurrent_devices'
            />
            <br />
            <BenefitTrans
              ns={CHECKOUT_I18N_NAMESPACE}
              i18nKey='plans.headers.offlineMode'
              tier={family}
              name='offline_download'
            />
          </>
        }
        label={t('plans.headers.cta.label', {
          plan: family.displayName,
        })}
        selectedLabel={t('plans.headers.cta.selected')}
        unselectedLabel={t('plans.headers.cta.select')}
        badge={familyBadge}
      />
    </>
  )
}
